import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getGoddivaUsProductsApi } from "../../../services/manage-product/goddivaUsProductService";

export const getGoddivaUsProducts = createAsyncThunk(
  "goddivaUsProduct/list",
  async (data) => {
    const res = await getGoddivaUsProductsApi(data);
    return res.response; // { data, pagination, conversion_rate, buffer }
  }
);

const initialState = {
  data: [],
  pagination: { total: 0, per_page: 20, current_page: 1, last_page: 1 },
  conversionRate: null,
  buffer: 3,
  loading: false,
};

const goddivaUsProductSlice = createSlice({
  name: "goddivaUsProduct",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGoddivaUsProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGoddivaUsProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data || [];
        state.pagination = action.payload?.pagination || state.pagination;
        state.conversionRate =
          action.payload?.conversion_rate ?? state.conversionRate;
        state.buffer = action.payload?.buffer ?? state.buffer;
      })
      .addCase(getGoddivaUsProducts.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default goddivaUsProductSlice.reducer;
